import { Injectable } from '@angular/core'

import { Category } from 'app/_shared/interfaces/Category'

import { IApiPaginatedData } from '../interfaces/IApiPaginatedData'
import { Product } from '../interfaces/Product'
import { ApiService } from './api.service'

@Injectable({
  providedIn: 'root'
})
export class ProductService extends ApiService {
  getProducts(storefrontId: number, query?: any) {
    const relations = ['productThumbnail', 'productVariants', 'productVariants.variantThumbnail']
    const params: Record<string, string | number | Array<string | number>> = {
      'relations[]': relations
    }

    if (query) {
      Object.keys(query).forEach(key => {
        const value = query[key]

        if (value !== undefined && value !== null) {
          params[key] = value
        }
      })
    }

    return this.get<IApiPaginatedData<Product[]>>(
      `${this.apiUrl}/storefronts/${storefrontId}/storefront-products`,
      { params }
    )
  }

  getWidgetProducts(storefrontId: number, params: any) {
    return this.get<IApiPaginatedData<Product[]>>(
      `${this.apiUrl}/storefronts/${storefrontId}/storefront-products`,
      { params }
    )
  }

  getBrandsAndColors(storefrontId: number) {
    return this.get<{ brands: string[]; colors: string[] }>(`${this.apiUrl}/brands/colors`, {
      params: { storefront_id: storefrontId }
    })
  }

  getProductCategories(storefrontId: number, companyCategoryId?: number) {
    const id = companyCategoryId ? `?company_category_id=${companyCategoryId}` : ''
    return this.get<Category[]>(
      `${this.apiUrl}/storefronts/${storefrontId}/has-products/product-categories${id}`
    )
  }

  getProduct(storefrontId: number, productSlug: string) {
    const relations = [
      'productVariants.productVariantSizes.priceRanges',
      'productCategories',
      'productVariants.variantImages',
      'productVariants.catalogProductVariant.supplierProductVariant.swatchImages',
      'productVariants.productVariantSizes.catalogVariantSizeQuantity',
      'warehouse',
      'reviews',
      'additionalPhotos',
      'decorationMethods',
      'catalogProduct.decorationMethods',
      'catalogProduct.catalogable.supplierProductSizeGuides.supplierProductSizeGuideSizes',
      'productThumbnail',
      'inputFields'
    ]

    return this.get<Product>(
      `${this.apiUrl}/storefronts/${storefrontId}/storefront-products/${productSlug}`,
      {
        params: {
          'relations[]': relations
        }
      }
    )
  }

  getProductCategoryBySlug(storefrontId: number, slug: string) {
    return this.get<any>(
      `${this.apiUrl}/storefronts/${storefrontId}/product-categories/slug/${slug}`
    )
  }
}
